import { component } from "picoapp";

export const siteSearch = component((node: HTMLElement) => {
  const form = node.querySelector<HTMLFormElement>("form");
  const q = node.querySelector<HTMLInputElement>("input[name=q]");

  if (!form || !q) {
    return;
  }

  const maestroConstants = {
    "dest url": null,
    "dest path": null,
    "from url": window.location.href,
    "from path": window.location.pathname,
    data: null,
    target: form.nodeName.toLowerCase(),
    "page section": node.dataset.mtrSection,
    position: null,
  };

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault();

    window.maestro.fireTrackEvent("submitSiteSearch", {
      ...maestroConstants,
      "search terms": q.value,
      "search type": "manual",
    });

    form.submit();
  };

  const searchTerms = node.querySelector<HTMLInputElement>(
    "input[name=search_terms]"
  );
  const resultsCount = node.querySelector<HTMLInputElement>(
    "input[name=search_results_count]"
  );
  const searchResults = node.querySelector<HTMLInputElement>(
    "input[name=search_results]"
  );

  if (!searchTerms) {
    return;
  }

  window.maestro.fireTrackEvent("viewSearchResults", {
    ...maestroConstants,
    "search terms": searchTerms.value,
    "results count": resultsCount?.value,
    "displayed results": searchResults?.value
      ? JSON.parse(searchResults?.value)
      : null,
  });

  form.addEventListener("submit", handleSubmit);

  return () => {
    form.removeEventListener("submit", handleSubmit);
  };
});
